import { format } from "date-fns";
import { ROUTES, callAPI } from "../API/index";

// -----------------------------------------------
// Attendance
// -----------------------------------------------
export const fetchAttendanceTag = (atend_no) => {
    /**
     * 근태 태그 조회
     */
    return callAPI(ROUTES.ATTENDANCE.WORK_TIME, 'GET', {}, { atend_no });
}

export const fetchAttendanceTagStatus = () => {
    /**
     * 근태 태그 상태 조회
     * 반환 : hasCheckedIn
     */
    return callAPI(ROUTES.ATTENDANCE.WORK_TIME, 'GET');
}

export const createAttendanceTag = (apiData) => {
    /**
     * 근태 태그 생성
     */
    return callAPI(ROUTES.ATTENDANCE.WORK_TIMES, 'POST', apiData);
}

export const fetchAttendanceTagList = (str, end, employeeNos) => {
    /**
     * 근태 태그 목록 반환 - 출퇴근 기록 반환
     */
    return callAPI(ROUTES.ATTENDANCE.WORK_TIMES, 'GET', {}, { str, end, employeeNos });
}

export const fetchAttendanceDailyWorks = (str, end, employeeNos) => {
    /**
     * 사원 일별 근태 조회
     */
    return callAPI(ROUTES.ATTENDANCE.DAILY_WORKS, 'GET', {}, { str, end, employeeNos });
}

export const fetchAttendanceDailyWork = (empl_no, workDate) => {
    /**
     * 사원 일별 근태 조회 - 1건
     */
    return callAPI(ROUTES.ATTENDANCE.DAILY_WORK, 'GET', {}, { empl_no, workDate });
}

export const updateAttendanceDailyWork = (empl_no, formData) => {
    /**
     * 사원 일별 근태 수정
     */

    const formattedWorkDate = formData.workDate ?
        (typeof formData.workDate === 'string' ? formData.workDate : format(formData.workDate, 'yyyy-MM-dd'))
        : undefined;

    const formattedAtendTime = formData.atendTime ?
        (typeof formData.atendTime === 'string' ? formData.atendTime : format(formData.atendTime, 'HH:mm'))
        : undefined;

    const formattedLvofcTime = formData.lvofcTime ?
        (typeof formData.lvofcTime === 'string' ? formData.lvofcTime : format(formData.lvofcTime, 'HH:mm'))
        : undefined;

    const formattedGnot = formData.gnot ?
        (typeof formData.gnot === 'string' ? formData.gnot : format(formData.gnot, 'HH:mm'))
        : undefined;

    const formattedRtn = formData.rtn ?
        (typeof formData.rtn === 'string' ? formData.rtn : format(formData.rtn, 'HH:mm'))
        : undefined;

    const formattedLatenTime = formData.latenTime ?
        (typeof formData.latenTime === 'string' ? formData.latenTime : format(formData.latenTime, 'HH:mm'))
        : undefined;

    const formattedGnotTime = formData.gnotTime ?
        (typeof formData.gnotTime === 'string' ? formData.gnotTime : format(formData.gnotTime, 'HH:mm'))
        : undefined;

    const formattedElpdAtend = formData.elpdAtend ?
        (typeof formData.elpdAtend === 'string' ? formData.elpdAtend : format(formData.elpdAtend, 'HH:mm'))
        : undefined;

    const formattedExtnWork = formData.extnWork ?
        (typeof formData.extnWork === 'string' ? formData.extnWork : format(formData.extnWork, 'HH:mm'))
        : undefined;

    const formattedExtnNightWork = formData.extnNightWork ?
        (typeof formData.extnNightWork === 'string' ? formData.extnNightWork : format(formData.extnNightWork, 'HH:mm'))
        : undefined;

    const formattedNightWork = formData.nightWork ?
        (typeof formData.nightWork === 'string' ? formData.nightWork : format(formData.nightWork, 'HH:mm'))
        : undefined;

    const formattedHdayWork = formData.hdayWork ?
        (typeof formData.hdayWork === 'string' ? formData.hdayWork : format(formData.hdayWork, 'HH:mm'))
        : undefined;

    const formattedHdayExtnWork = formData.hdayExtnWork ?
        (typeof formData.hdayExtnWork === 'string' ? formData.hdayExtnWork : format(formData.hdayExtnWork, 'HH:mm'))
        : undefined;

    const formattedHdayNightWork = formData.hdayNightWork ?
        (typeof formData.hdayNightWork === 'string' ? formData.hdayNightWork : format(formData.hdayNightWork, 'HH:mm'))
        : undefined;

    const formattedHdayExtnNightWork = formData.hdayExtnNightWork ?
        (typeof formData.hdayExtnNightWork === 'string' ? formData.hdayExtnNightWork : format(formData.hdayExtnNightWork, 'HH:mm'))
        : undefined;

    const formattedRealWork = formData.realWork ?
        (typeof formData.realWork === 'string' ? formData.realWork : format(formData.realWork, 'HH:mm'))
        : undefined;

    const formattedNormalWork = formData.normalWork ?
        (typeof formData.normalWork === 'string' ? formData.normalWork : format(formData.normalWork, 'HH:mm'))
        : undefined;

    const formattedBreakTime = formData.breakTime ?
        (typeof formData.breakTime === 'string' ? formData.breakTime : format(formData.breakTime, 'HH:mm'))
        : undefined;

    const formattedHdayPayWork = formData.hdayPayWork ?
        (typeof formData.hdayPayWork === 'string' ? formData.hdayPayWork : format(formData.hdayPayWork, 'HH:mm'))
        : undefined;

    const formmatedFormData = {
        workDate: formattedWorkDate,
        workSch: formData.workSch || undefined,
        atendTime: formattedAtendTime,
        lvofcTime: formattedLvofcTime,
        gnot: formattedGnot,
        rtn: formattedRtn,
        atendJdgmntCode: formData.atendJdgmntCode || undefined,
        lvofcJdgmntCode: formData.lvofcJdgmntCode || undefined,
        latenTime: formattedLatenTime,
        gnotTime: formattedGnotTime,
        elpdAtend: formattedElpdAtend,
        extnWork: formattedExtnWork,
        extnNightWork: formattedExtnNightWork,
        nightWork: formattedNightWork,
        hdayWork: formattedHdayWork,
        hdayExtnWork: formattedHdayExtnWork,
        hdayNightWork: formattedHdayNightWork,
        hdayExtnNightWork: formattedHdayExtnNightWork,
        realWork: formattedRealWork,
        normalWork: formattedNormalWork,
        breakTime: formattedBreakTime,
        hdayPayWork: formattedHdayPayWork,
    }
    console.log(formmatedFormData)
    return callAPI(ROUTES.ATTENDANCE.DAILY_WORK, 'POST', formmatedFormData, { empl_no });
}

export const fetchAttendanceManagement = (month, userNo) => {
    /**
     * 근태 관리 조회
     */
    return callAPI(ROUTES.ATTENDANCE.MANAGEMENT, 'GET', {}, { month, userNo });
}

export const createAttendanceManagement = (month, userNo) => {
    // 근태 관리 생성
    return callAPI(ROUTES.ATTENDANCE.MANAGEMENT, 'POST', { month, userNo });
}

export const updateAttendanceManagement = (apiData) => {
    /**
     * 근태 관리 수정
     */
    return callAPI(ROUTES.ATTENDANCE.MANAGEMENT, 'PUT', apiData);
}

export const fetchCalTime = (empl_no, formData) => {
    /**
     * 근태 관리 계산
     */
    const formattedWorkDate = formData.workDate ?
        (typeof formData.workDate === 'string' ? formData.workDate : format(formData.workDate, 'yyyy-MM-dd'))
        : undefined;

    const formattedAtendTime = formData.atendTime ?
        (typeof formData.atendTime === 'string' ? formData.atendTime : format(formData.atendTime, 'HH:mm'))
        : undefined;

    const formattedLvofcTime = formData.lvofcTime ?
        (typeof formData.lvofcTime === 'string' ? formData.lvofcTime : format(formData.lvofcTime, 'HH:mm'))
        : undefined;

    const formattedGnot = formData.gnot ?
        (typeof formData.gnot === 'string' ? formData.gnot : format(formData.gnot, 'HH:mm'))
        : undefined;

    const formattedRtn = formData.rtn ?
        (typeof formData.rtn === 'string' ? formData.rtn : format(formData.rtn, 'HH:mm'))
        : undefined;

    const workSch = formData.workSch ? formData.workSch : '0001';

    return callAPI(ROUTES.ATTENDANCE.MANAGEMENT.RECALCULATION, 'GET', {}, { 
        empl_no, 
        workDate: formattedWorkDate, 
        atendTime: formattedAtendTime, 
        lvofcTime: formattedLvofcTime, 
        gnot: formattedGnot, 
        rtn: formattedRtn, 
        workSch 
    });
}

export const recalculationAll = (empl_nos, workDateStart, workDateEnd, workSch, atendTime, lvofcTime, useHoliday) => {
    /**
     * 근태 관리 계산 - 전체 직원
     * @param {string} workDateStart - 근무시작일자
     * @param {string} workDateEnd - 근무종료일자
     * @param {string} workSch - 근무코드
     * @param {string} atendTime - 근무시작시간
     * @param {string} lvofcTime - 근무종료시간
     * @param {boolean} useHoliday - 휴일 적용 여부
     */
    const apiData = {
        workDateStart: workDateStart,
        workDateEnd: workDateEnd,
        employeeNos: empl_nos,
        workSch: workSch,
        ...(atendTime && { atendTime: typeof atendTime === 'string' ? atendTime : format(atendTime, 'HH:mm') }),
        ...(lvofcTime && { lvofcTime: typeof lvofcTime === 'string' ? lvofcTime : format(lvofcTime, 'HH:mm') }),
        ...(useHoliday && { useHoliday: useHoliday })
    }
    return callAPI(ROUTES.ATTENDANCE.RECALCULATION_ALL, 'POST', apiData);
}